__turbopack_context__.v({
  "className": "open_sans_23468dd5-module__Pqdljq__className",
  "variable": "open_sans_23468dd5-module__Pqdljq__variable",
});
